// extracted by mini-css-extract-plugin
export var animationContainer = "_jv-0";
export var footer = "_jv-1";
export var gray = "_jv-2";
export var lineItem = "_jv-3";
export var lineItemImage = "_jv-4";
export var lineItemInfo = "_jv-5";
export var lineItemText = "_jv-6";
export var lineItems = "_jv-7";
export var modalContent = "_jv-8";
export var options = "_jv-9";
export var orderName = "_jv-a";
export var refundAmount = "_jv-b";